export const HW_COMPONENTS: string[] = [
  "Charging Station 1",
  "Charging Station 2",
  "EOL Jig",
  "Genius 2",
  "Handheld Controller",
  "Mecanum Wheel",
  "Portable Charger",
  "Single Point Charger",
];

